import script from "./ChatListHead.vue?vue&type=script&setup=true&lang=js"
export * from "./ChatListHead.vue?vue&type=script&setup=true&lang=js"

import "./ChatListHead.vue?vue&type=style&index=0&id=d4d2e5bc&lang=scss"

const __exports__ = script;

export default __exports__